import dayjs from 'dayjs';

const formatoMoedaPtBr = new Intl.NumberFormat('pt-BR', {
    style: 'decimal',
    currency: 'BRL',
    minimumFractionDigits: 2
});

const encontrar = (objeto: any, caminho: string[]): any => {
    if(caminho.length == 0) return objeto;
    const t = objeto[caminho[0]];
    return typeof t == "object" ? encontrar(t, caminho.slice(1)) : t;
}

function textContent(elem: React.ReactElement | string): string {
    /* https://stackoverflow.com/a/63173682 */

    if (!elem) {
        return "";
    }
    if (typeof elem === "string") {
        return elem;
    }

    const children = elem.props && elem.props.children;
    if (children instanceof Array) {
        return children.map(textContent).join("");
    }
    return textContent(children);
}

const Utilitario = {

    encontrar: encontrar,

    enumParaString : function (enum_: Record<number, string>, chave: number | undefined): string | undefined {
        if(typeof enum_ != "object") return undefined;
        if(chave == undefined) return undefined;
        return Object.entries(enum_).find(([k, v]) => k == chave.toString())?.[1]
    },

    /**
     * @returns e.g. 'alguma coisa' -> 'Alguma Coisa'
     */
    capitalizarIniciais: (v?: string) => v == undefined ? undefined : v.split(" ").map((m) => m.charAt(0).toUpperCase() + m.slice(1,).toLowerCase()).join(" "),

    /**
     * @returns e.g. 'alguma coisa' -> 'Alguma coisa'
     */
    capitalizarInicial: (v?: string) => v == undefined ? undefined : v.charAt(0).toUpperCase() + v.slice(1,).toLowerCase(),

    toStringDinheiro : function (valor?: number | null) {
        return !valor || isNaN(valor) ? formatoMoedaPtBr.format(0.00) : formatoMoedaPtBr.format(valor);
    },

    toCSVDinheiro : function (valor?: number | null): string {
        if(!Number.isFinite(valor)) return this.toCSVDinheiro(0);
        return valor!.toFixed(2).replace(".", ",");
    },

    toDate: function (strDate:string) {
        const dataArray = strDate.split('/').map(parseInt);
        return new Date(dataArray[2], dataArray[1] - 1, dataArray[0]);
    },

    /**
     * Função converte a data em uma string de acordo com o tamplate passado
     * @param {Date} date Data que será tranformada.
     * @param {string} tamplate String Tamplate.
     */
    dateToString: function (dateEntrada:Date|dayjs.Dayjs, tamplate:'dd/MM/yyyy'|'dd/MM'|'MMM'|'dd/MM/yyyy hh:mm:ss' = 'dd/MM/yyyy') {
        if (dateEntrada === null || dateEntrada === undefined) return '';
        
        const date = dayjs.isDayjs(dateEntrada) ? dateEntrada.toDate() : (typeof dateEntrada === "string" ? new Date(dateEntrada) : dateEntrada);
        
        if (date === null || date === undefined || !(date instanceof Date)) return '';
        
        const ano = date.getFullYear();
        const mes = (date.getMonth() + 1).toString().padStart(2, '0');
        const dia = date.getDate().toString().padStart(2, '0');
        const hora = date.getHours();
        const minuto = date.getMinutes();
        const segundo = date.getSeconds();
        
        switch (tamplate)
        {
            case 'dd/MM':
                return `${dia}/${mes}`;
            case 'dd/MM/yyyy hh:mm:ss':
                return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
            case 'MMM':
                return Utilitario.mesDescricao(Number(mes) - 1);
            default:
                return `${dia}/${mes}/${ano}`;
        }
    },
    
    diferancaEntreDatas: function (dataBase:Date, dataComparacao:Date) {
        let diferenca = Math.abs(dataBase.getTime() - dataComparacao.getTime());
        return Math.ceil(diferenca / (1000 * 3600 * 24));
    },

    mesesBr : ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],

    mesDescricao(intMes:number) {
        return Utilitario.mesesBr[intMes];
    },
    
    groupBy : function <TValor, TChave> (
        list:TValor[], 
        callbackExtrairChave:(valor:TValor, indice:number, listaOriginal:TValor[]) => TChave
    ) {
        return list.reduce((acumulador, valor, indece, listaOriginal) => {
            //Obtem a chave do grupo pelo callback
            const chave = callbackExtrairChave(valor, indece, listaOriginal);
            //Verifica se a chave não existe no acumulador, caso adiciona ela com o vetor vazio
            if (!acumulador.some(any => any.chave === chave))
                acumulador.push({
                    chave: chave,
                    data: []
                });
            //Carrega no acumulador o valor atual de acordo com a chave a qual pertence
            acumulador.find(f => f.chave === chave)!.data.push(valor);
            //Retorna o acumulador para proxima redução
            return acumulador;
        }, [] as IGroup<TValor, TChave>[]);
    },

    zip: function<T>(arrays: T[][]){
        const least = Math.min(...arrays.map((ar) => ar.length));
        const ret: T[][] = Array(least)
            .fill(0)
            .map(() => []);

        for (let i = 0; i < least; i++) {
            for (let j = 0; j < arrays.length; j++) {
                ret[i].push(arrays[j][i]);
            }
        }

        return ret;
    },

    textContent: textContent
}

export default Utilitario;

export interface IGroup<T, K> {
    chave: K; 
    data: Array<T>;
}